import "babel-polyfill";//es6转es5兼容IE
import "url-search-params-polyfill";//让ie兼容new URLSearchParams()
import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import config from './assets/js/conf/config';
import utils from './assets/js/utils';
import filters from './assets/js/utils/firlter';

import Fingerprint2 from 'fingerprintjs2';

// @import "./assets/css/common/public.css";

// 公共css样式文件
import '@/assets/css/common/public.css';

// 淘宝无限适配
import '@/assets/js/libs/flexible.js'





function createFingerprint() {

  return new Promise((resolve, reject) => {
    Fingerprint2.get(async (components) => {
      const values = components.map((component, index) => {
        if (index === 0) { // 把微信浏览器里的UA的WIFI或4G等网络替换成空
          return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
      })
      //murmur浏览器指纹
      const murmur = Fingerprint2.x64hash128(values.join(''), 31);
      window.sessionStorage.setItem("serial_number", murmur); //存入标识值
      return resolve();

      // // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
      // let values = components.map((component) => component.value) // 配置的值的数组
      // let murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹        
      // //murmur浏览器指纹
      // window.sessionStorage.setItem("serial_number", murmur); //存入标识值
      // console.log(murmur);

    })
  })

  return false
  const fingerprint = Fingerprint2.get(async (components) => {
    // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
    let values = components.map((component) => component.value) // 配置的值的数组
    let murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹        
    //murmur浏览器指纹
    window.sessionStorage.setItem("serial_number", murmur); //存入标识值
    console.log(murmur);
  })
}

var serial_number = sessionStorage.getItem("serial_number");
if (!serial_number) {
  createFingerprint()
}




Vue.config.productionTip = false;
Vue.prototype.$config = config;
Vue.prototype.$utils = utils;


// filters 全局过滤器
// for(const key in filters){
//     Vue.filter(key,filters[key])
// }
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');


